import { useBankProfile } from '@contexts/BankProfileContext';
import { Loader } from '@gurupay/gp-ui-library';
import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { Capability } from 'types/roles';

interface RoleGuardProps {
	capability: Capability;
	children: ReactNode;
	fallbackRoute?: string;
}

export const RoleGuard = ({
	capability,
	children,
	fallbackRoute = '/dashboard',
}: RoleGuardProps) => {
	const { hasCapability, selectedProfile, profilesUnavailable } = useBankProfile();

	if (!selectedProfile) {
		if (profilesUnavailable) {
			return <Navigate replace to={fallbackRoute} />;
		}

		return (
			<div className="h-125 flex justify-center items-center">
				<Loader />
			</div>
		);
	}

	if (!hasCapability(capability)) {
		return <Navigate replace to={fallbackRoute} />;
	}

	return children;
};
